<template>
    <div class="user-login-5"
         v-loading.fullscreen.lock="loading"
         :element-loading-text="loadingMsg"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <swiper ref="mySwiper" :options="swiperOptions" v-if="inited">
            <swiper-slide v-for="img in images">
                <div class="login-bg" :style="{ backgroundImage: 'url(' + img + ')' }"></div>
            </swiper-slide>
            <!--<div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>-->
        </swiper>
        <div class="login-content">
            <div class="login-body">
                <div class="login-qrcode">
                    <img class="login-logo" :src="projectImg" v-if="projectImg && inited" />

                    <div class="login-qrcode-code">
                        <template v-if="wxQrcodeError">
                            微信登录未正确开启
                        </template>
                        <img v-else-if="wxLoginUrl" :src="wxLoginUrl" />
                    </div>
                    <div class="login-qrcode-tip">使用微信扫码登录</div>
                </div>
                <!--<p v-text="project.project_desc || '欢迎登录后台管理系统'" style="margin-top:10px;"></p>-->
                <div class="login-form">
                    <h1 v-text="project.project_name || '后台管理系统'"></h1>
                    <van-form @submit="submit" style="width: 300px;height: 190px;margin: 10px auto;">
                        <van-field
                                v-model="account"
                                name="用户名"
                                label=""
                                placeholder="用户名"
                                :rules="[{ required: true, message: '请填写用户名' }]"
                                @keyup.enter.native="submit"></van-field>
                        <van-field
                                v-model="password"
                                type="password"
                                name="密码"
                                label=""
                                placeholder="密码"
                                :rules="[{ required: true, message: '请填写密码' }]"
                                @keyup.enter.native="submit"></van-field>
                        <van-field v-model="captcha" name="验证码" label="" placeholder="验证码"
                                   :rules="[{ required: true, message: '请填写验证码' }]" @keyup.enter.native="submit">
                            <template #button>
                                <div v-html="loginCaptchaSvg" v-if="captchaShow" class="login-captcha" @click="loadLoginCaptcha"></div>
                            </template>
                        </van-field>
                        <div></div>
                    </van-form>
                    <div style="width: 280px;">
                        <van-button round block type="info" @click="submit">提交</van-button>
                    </div>
                </div>
            </div>
            <!--<div class="login-copyright">
                <p>Copyright &copy; JUZHILE.CC 2018</p>
            </div>-->
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import _ from 'lodash';

    const IMAGES = [
        "/assets/images/login/bg3.jpg",
        "/assets/images/login/bg2.jpg",
        "/assets/images/login/bg1.jpg"
    ];

    export default {
        data() {
            return {
                projectId: null,
                project: {},
                account: '',
                password: '',
                captcha: '',
                loginCaptchaSvg: '',
                captchaShow: false,

                loading: false,
                loadingMsg: '加载中，请稍后...',
                inited: false,
                wxLoginUrl: '',
                wxQrcodeError: false,
                wxQrcodeTitle: '扫码登录',
                swiperOptions: {
                    // spaceBetween: 30,
                    // centeredSlides: true,
                    observer:true,          //修改swiper自己或子元素时，自动初始化swiper
                    observeParents:true,    //修改swiper的父元素时，自动初始化swiper
                    loop : true,
                    // autoplay: true,
                    autoplay: {
                        delay: 5000,
                    },
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    /*effect: 'coverflow',
                    coverflowEffect: {
                        rotate: 30,
                        slideShadows: false,
                    },*/
                    /*effect: 'flip',
                    flipEffect: {
                        slideShadows: false,
                    },*/
                    /*effect: 'cube',
                    cubeEffect: {
                        slideShadows: false,
                    },*/
                    /*pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }*/
                }
            }
        },
        async created () {

        },
        computed: {
            projectImg() {
                return _.get(this.project, 'project_logo') || '/assets/images/logo-rect.png';
            },
            images() {
                let imgs = _.filter(_.map(_.get(this.project, "images"), "file_path"), p=> p);

                if(imgs && imgs.length > 0) {
                    return imgs;
                }
                return IMAGES;
            }
        },
        async mounted () {
            let pid = await this.$getCurrentProjectId();

            if(!pid) pid = this.$utils.getQueryString("__pid", 4) || this.$utils.getQueryString("pid", 3);
            this.projectId = pid;

            this.showLoading("页面加载中...");
            await this.initProjectInfo();
            this.$nextTick(() => {
                this.hideLoading();
                this.inited = true;
                this.initQrcode();

                setTimeout(async () => {
                    await this.loadLoginCaptcha();
                    this.captchaShow = true;
                }, 500);
            })
        },
        beforeDestroy() {
            this.removeTimeout();
        },
        methods: {
            ...mapActions([
                // 'changeProject',
                'initLoginUser'
            ]),
            showLoading(msg) {
                this.loading = true;
                this.loadingMsg = msg;
            },
            hideLoading() {
                this.loading = false;
            },
            async initProjectInfo() {

                if(!this.projectId) return;

                let project = await this.$japi.project.getProject(this.projectId);

                if(project) {
                    this.project = project;

                    let plogo = _.get(project, "project_logo");
                    let pico = _.get(project, "project_ico");
                    let pname = _.get(project, "project_name");

                    this.$utils.setTitleFavicon(pname, pico || plogo);
                }
                await this.loadLoginCaptcha();
            },
            async submit(){
                if (!this.account || !this.password || !this.captcha) {
                    this.$jui.toast('用户名/密码/验证码不能为空！');
                    return;
                }
                this.showLoading('登录中，请稍后。。。');

                let data = await this.$jeapi.admin.login(this.account, this.password, this.captcha);

                this.hideLoading();
                if (data) {
                    await this.initLoginUser(data);

                    this.$router.replace({
                        name: 'index',
                        replace: true
                    });
                } else {
                    this.loadLoginCaptcha();
                }
            },
            async loadLoginCaptcha() {
                let ret = await this.$japi.passport.getCaptcha("login");
                this.loginCaptchaSvg = ret;
            },
            async initQrcode() {

                let url = await this.$japi.weixin.getWxspTmpQrcode();

                if(url) {
                    // this.wxQrcodeError = false;
                    this.wxLoginUrl = url;
                    this.startTimeout();
                } else {
                    this.wxQrcodeError = true;
                }
            },
            startTimeout() {
                this.timeout = setTimeout(this.checkLoginStatus, 1500);
            },
            removeTimeout() {
                if(this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = null;
                }
            },
            async checkLoginStatus() {

                if(this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = null;
                }
                let ret = await this.$japi.weixin.checkWxspTmpQrcodeLogin();
                let status = _.get(ret, 'status');

                if(status === 'SUCCESS') {  // 登录成功
                    let data = _.get(ret, 'data');
                    let loginAdminType = _.get(data, "admin.type");

                    if(_.indexOf([ "MGR", "SUPER", "_SUPER" ], loginAdminType) >= 0) {
                        await this.initLoginUser(data);

                        this.$router.replace({
                            name: 'index',
                            replace: true
                        });
                    } else {
                        this.$alert(`<strong style="font-size: 15px;letter-spacing: 2px">请使用<i style="color: #409EFF;">已绑定</i> 管理员账号的微信扫码登录！</strong>`, '提示', {
                            dangerouslyUseHTMLString: true,
                            type: 'warning',
                            center: true
                        }).then(() => {
                            this.initQrcode();
                        }).catch(() => {
                            this.initQrcode();
                        });
                    }
                } else {    // 等待
                    this.startTimeout();
                }
            },
            handleClose(done) {
                done();
                this.removeTimeout();
            }
        }
    }
</script>

<style scoped lang="scss">
    .user-login-5 {
        background: #333;
    }
    .login-content {
        text-align: center;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        position: fixed;
        left: 0px;
        top: 0px;
        right: 0px;
        bottom: 0px;
        z-index: 1000;

        .login-body {
            width: 700px;
            height: 400px;
            /*background: rgba(255, 255, 255, 0.8);*/
            display: flex;
            align-items: stretch;
            /*box-shadow: 0 0 10px #000;*/
        }

        .login-qrcode {
            width: 320px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #FFF;
            border-right: 1px solid #EEE;
            background: rgba(255, 255, 255, .6);

            .login-logo {
                max-height: 42px;
                max-width: 278px;
                position: absolute;
                left: 20px;
                top: 20px;
            }
            .login-qrcode-code {
                width: 220px;
                height: 220px;
                top: 100px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 5px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .login-qrcode-tip {
                position: absolute;
                bottom: 20px;
                text-align: center;
                width: 100%;
                color: #444;
                letter-spacing: 2px;
            }
        }

        /*.login-header {
            color: #EEE;

            h1 {
                font-size: 30px;
            }
        }*/
        .logo-img-wrap {
            overflow: hidden;
            margin-bottom: 20px;
        }
        .logo-img-wrap img {
            max-width: 300px;
            max-height:60px;
        }

        .login-form {
            flex: 1;
            display: flex;
            align-items: center;
            flex-flow: column;
            justify-content: center;
            background:#FEFEFE;
            padding: 15px;
            /*border-radius: 10px;*/
            /*background: rgba(255, 255, 255, .8);*/
            /*margin-top: 20px;
            margin-bottom: 120px;*/

            h1 {
                font-size: 28px;
                margin: 0px;
                margin-bottom: 20px;
            }
        }
    }

    .login-bg {
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        min-height: 100vh;
    }
    .login-copyright {
        text-align: center;
        position: absolute;
        bottom: 0px;
        left: 0;
        right: 0;
        color: #CCC;
    }
</style>
<style lang="scss">
    .login-captcha {
        height: 34px;
        width: 100px;
        margin-top: -5px;
        margin-bottom: -5px;

        > svg {
            width: 100%;
            height: 100%;
        }
    }
</style>
